import axios from 'axios'
import store from '../store'
import { Message } from 'element-ui'
// 设置了路由拦截  这里清掉token 就会跳回登录页
// 请求拦截器
axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    } else {
      config.headers['token'] = ''
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// 响应拦截器
axios.interceptors.response.use(res => {
  let data = res.data

  if (data.code === 0) {
    return res.data
  } else {
    Message({
      message: data.msg,
      type: 'error'
    })

    let code = data.code

    if (code === 1) {
      window.location.href = '/'
    }

    return null
  }
}, error => {
  Message({
    message: error.message,
    type: 'error'
  })
})
export default axios
